import React, { useState, useRef } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import { company } from "../mock";
import { trackConversion, CONV } from "../lib/gtag";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/catalog`;

export default function InlineQuoteForm() {
  const [form, setForm] = useState({ name: "", codice: "", marca: "", modello: "", phone: "", email: "", note: "" });
  const [errors, setErrors] = useState({});
  const cardRef = useRef(null);

  const set = (k, v) => { setForm((f) => ({ ...f, [k]: v })); setErrors((e) => ({ ...e, [k]: null })); };

  // 3D tilt effect following the cursor
  const onMove = (e) => {
    const el = cardRef.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(900px) rotateY(${px * 5}deg) rotateX(${-py * 5}deg) translateY(-2px)`;
  };
  const onLeave = () => { if (cardRef.current) cardRef.current.style.transform = "perspective(900px) rotateY(0) rotateX(0)"; };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Campo obbligatorio";
    if (!form.phone.trim()) e.phone = "Campo obbligatorio";
    else if (!/^[+]?[\d\s().-]{6,}$/.test(form.phone.trim())) e.phone = "Numero non valido";
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) e.email = "Email non valida";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const buildWa = () => {
    const l = [`Ciao ${company.name}, vorrei un preventivo:`, `Nome / Ragione sociale: ${form.name}`];
    if (form.codice) l.push(`Codice motore: ${form.codice}`);
    if (form.marca) l.push(`Marca: ${form.marca}`);
    if (form.modello) l.push(`Modello: ${form.modello}`);
    l.push(`Telefono: ${form.phone}`);
    if (form.email) l.push(`Email: ${form.email}`);
    if (form.note) l.push(`Note particolari: ${form.note}`);
    return encodeURIComponent(l.join("\n"));
  };

  // Submit: open WhatsApp synchronously (same click tick, avoids popup block) + save lead in background
  const submit = (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    const engineTitle = [form.marca, form.modello].filter(Boolean).join(" ").trim() || null;
    axios.post(`${API}/leads`, {
      name: form.name.trim(),
      phone: form.phone.trim(),
      email: form.email.trim() || null,
      note: form.note.trim() || null,
      engine_code: form.codice.trim() || null,
      engine_title: engineTitle,
    }).catch((e) => console.error("Lead save failed", e));
    trackConversion(CONV.preventivo);
    trackConversion(CONV.contatto);
    window.open(`https://wa.me/${company.wa}?text=${buildWa()}`, "_blank");
  };

  return (
    <div className="inline-quote tilt-card" ref={cardRef} onMouseMove={onMove} onMouseLeave={onLeave}>
      <div className="inline-quote-head">
        <h3>Richiedi il tuo preventivo</h3>
        <span>Compila e invia direttamente su WhatsApp · Risposta in giornata</span>
      </div>
      <form onSubmit={submit} noValidate>
        <div className="eq-field">
          <label>Nome e Cognome o Ragione sociale <span className="req">*</span></label>
          <input className={errors.name ? "error" : ""} value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Es. Mario Rossi / Autofficina Rossi S.r.l." />
          {errors.name && <div className="err-msg">{errors.name}</div>}
        </div>
        <div className="eq-field">
          <label>Codice motore <span className="opt">(opzionale)</span></label>
          <input value={form.codice} onChange={(e) => set("codice", e.target.value)} placeholder="Es. BKD, 199A3, F9Q… (voce P.5 del libretto)" />
        </div>
        <div className="eq-row-2">
          <div className="eq-field">
            <label>Marca <span className="opt">(opzionale)</span></label>
            <input value={form.marca} onChange={(e) => set("marca", e.target.value)} placeholder="Es. Fiat" />
          </div>
          <div className="eq-field">
            <label>Modello <span className="opt">(opzionale)</span></label>
            <input value={form.modello} onChange={(e) => set("modello", e.target.value)} placeholder="Es. Ducato" />
          </div>
        </div>
        <div className="eq-row-2">
          <div className="eq-field">
            <label>Telefono <span className="req">*</span></label>
            <input className={errors.phone ? "error" : ""} inputMode="tel" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Es. 333 1234567" />
            {errors.phone && <div className="err-msg">{errors.phone}</div>}
          </div>
          <div className="eq-field">
            <label>Email <span className="opt">(opzionale)</span></label>
            <input className={errors.email ? "error" : ""} type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="La tua email" />
            {errors.email && <div className="err-msg">{errors.email}</div>}
          </div>
        </div>
        <div className="eq-field">
          <label>Note particolari <span className="opt">(opzionale)</span></label>
          <textarea rows={2} value={form.note} onChange={(e) => set("note", e.target.value)} placeholder="Anno, allestimento, urgenza, altre richieste…" />
        </div>
        <button type="submit" className="btn btn-whatsapp" style={{ width: "100%", justifyContent: "center" }}>
          <MessageCircle size={18} /> Invia richiesta su WhatsApp
        </button>
      </form>
    </div>
  );
}
